import packageJson from '../../package.json';

const pkg = packageJson as { title?: string; name?: string; version?: string };

/**
 * Configuration du layout (source unique).
 *
 * Grammaire visuelle reprise de Prodicee (docs/redesign/GRAMMAIRE-VISUELLE.md) :
 * habillage blanc (`colorScheme`) au lieu du dégradé bleu (`primaryColor`),
 * menu latéral statique, pied de page visible.
 *
 * Le titre du package (« Abonéo — Gestion des abonnements ») est découpé :
 * le nom court va dans la barre du haut, la suite en sous-titre.
 */
const [appName, appDescription] = (pkg.title || pkg.name || 'Abonéo').split(' — ');

export const APP_LAYOUT_CONFIG = {
    // Thème (le preset PrimeNG est fourni par app.config.ts : AboneoPreset)
    preset: 'Aura',
    primary: 'blue',
    surface: null,
    darkTheme: false,
    layoutTheme: 'colorScheme',

    // Menu
    menuMode: 'static',

    // Identité
    logoUrl: 'assets/logo-aboneo.svg',
    logoAlt: 'Abonéo',
    appName,
    appDescription: appDescription || 'Gestion des abonnements',
    appVersion: pkg.version,

    // Éléments d'interface
    showBreadcrumb: false,
    showFooter: true,
    showSearch: false,
    showSettings: false,

    // Barre du haut : le menu de profil est construit par AppTopbar
    // (changement de rôle, liens d'administrateur d'organisme, déconnexion).
    toolbarConfig: {
        leftItems: [],
        rightItems: [],
    },
};
